// extracted by mini-css-extract-plugin
export var paginationContainer = "_40-0";